export default __webpack_public_path__ + "static/media/icon_4.32fef275.svg";